import { useMemo } from 'react';
export const useMergeRefs = (...refs) => useMemo(() => (value) => {
    refs.forEach((ref) => {
        if (typeof ref === 'function') {
            ref(value);
            return;
        }
        if (ref != null) {
            ref.current = value;
        }
    });
}, 
// eslint-disable-next-line react-hooks/exhaustive-deps
refs);
